import View from 'view/view'
import windowView from 'shared/view/window'

const SecondaryNavigationView = View.extend({
    el: '.js-secondary-navigation',

    initialize() {
        // Only relevant for mobile because the entries would not always fit the page width
        if (!windowView.isMobile()) {
            return
        }

        this.$navigationElement = this.$('.js-secondary-navigation-scroll-container')
        this.navigationElementDom = this.$navigationElement.get(0)

        if (!this.navigationElementDom) {
            return
        }

        this.maxScrollWidth = this.navigationElementDom.scrollWidth - this.navigationElementDom.clientWidth
        // Reduce by one because the width sum of rendered .secondaryNavigation__topics might be slightly
        // higher than the element.scrollWidth because their widths are not full numbers
        // (as they are being rendered as table-cells)
        this.maxScrollWidth = this.maxScrollWidth - 1

        // Set correct scroll position
        this._setScrollPositionToActiveNavigationPoint()

        // Check for amount of nav items, remove gradients if there are less than 4
        if (this.$('.js-secondary-navigation-scroll-element').length < 4) {
            this.$el.addClass('secondaryNavigation-hideRightGradient')
            this.$el.removeClass('secondaryNavigation-showLeftGradient')
        }

        // Watch scroll position to set right and/or left gradients accordingly
        this.$navigationElement.on('scroll', this._watchScrollPosition.bind(this))
    },

    _setScrollPositionToActiveNavigationPoint() {
        const currentItem = this.$navigationElement.find('.is-active')

        if (!currentItem.length) {
            return
        }

        // Center the currentItem to the center of the navigation bar
        const scrollCenter = Math.ceil(currentItem.offset().left - (this.$el.width() - currentItem.width()) / 2)
        this.$navigationElement.scrollLeft(scrollCenter)

        // Make sure the gradient check will be called (Listener might not hit here)
        this._watchScrollPosition()
    },

    _watchScrollPosition() {
        const currentScrollPosition = this.$navigationElement.scrollLeft()

        if (currentScrollPosition >= this.maxScrollWidth) {
            this.$el.addClass('secondaryNavigation-hideRightGradient')
            this.$el.addClass('secondaryNavigation-showLeftGradient')
        } else if (currentScrollPosition > 0) {
            this.$el.removeClass('secondaryNavigation-hideRightGradient')
            this.$el.addClass('secondaryNavigation-showLeftGradient')
        } else {
            this.$el.removeClass('secondaryNavigation-showLeftGradient')
        }
    },

    destroy() {
        if (!windowView.isMobile()) {
            return
        }

        if (!this.$navigationElement) {
            return
        }

        this.$navigationElement.off('scroll')
    },
})

export default SecondaryNavigationView
